exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tct-form-error-presenter{background-color:#e1715b;color:#fff;padding:8px 16px}", ""]);

// exports
